import { render, staticRenderFns } from "./Psi.vue?vue&type=template&id=309afefd&scoped=true"
import script from "./Psi.vue?vue&type=script&lang=js"
export * from "./Psi.vue?vue&type=script&lang=js"
import style0 from "./Psi.vue?vue&type=style&index=0&id=309afefd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "309afefd",
  null
  
)

export default component.exports